export { default } from './StockColorPicker';
